import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0a68014"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"main\" data-v-f0a68014><svg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-f0a68014><circle cx=\"29.9999\" cy=\"29.9999\" r=\"25.5556\" fill=\"#F7981C\" data-v-f0a68014></circle><path d=\"M28.333 16.1113V31.6669H42.7775\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-f0a68014></path></svg><div class=\"title\" data-v-f0a68014>正在查询保单信息</div><div class=\"message\" data-v-f0a68014> 为了确保您能够享受“意外机损保险”保障服务，平安保<br data-v-f0a68014> 险会将您的“意外机损保险”保单信息同步极飞科技。 </div></div>", 1)

import { useRoute } from 'vue-router'
import AppHeader from '@/components/Header.vue'
import { useActiveHandle } from '@/compositions/insurance/useActiveHandle'


export default /*#__PURE__*/_defineComponent({
  __name: 'pay-check',
  setup(__props) {

// 订单查询页，目前仅用于激活设备后购买跳转的链接，请求完激活信息进行跳转
const $route = useRoute()
const sn = $route.query.eqSn as string
const activeKey = $route.query.activeKey as string
const client = $route.query.client as string
const { activeHandle } = useActiveHandle(sn, client, activeKey)

activeHandle(true)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "获取投保结果" }),
    _hoisted_1
  ], 64))
}
}

})